import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import AdminRoleDetail from './components/AdminRoleDetail.vue';
let default_1 = class extends Vue {};
default_1 = __decorate([Component({
  name: 'ManageAdminRole',
  components: {
    AdminRoleDetail
  },
  props: ['isEdit']
})], default_1);
export default default_1;